module.exports = __webpack_public_path__ + "img/AVFC_FCP_2.5cbfe52.jpg";